export class ModulProp {
	// Module Orientation
	public static ORIENTATION_VERTICAL: number = 1;
	public static ORIENTATION_HORIZONTAL: number = 0;
	// Module Type
	public static TYPE_MONO: number = 1;
	public static TYPE_POLY: number = 2;
	public static TYPE_THIN: number = 3;
	// Module Invalidation
	public static INVALID_NONE: number = 0;
	public static INVALID_FULL: number = 1;
	// Module cantilever
	public static CANTILEVER_OFF: number = 0;
	public static CANTILEVER_ON: number = 1;
}